import ga4 from "@/lib/tracking/ga4Core";

const SEND_PAYMENT_JOURNEY_DETAILS = "send_payment_request_link";

export const trackExclusiveProjectClick = ({ target }) => {
  const eventName = "click_interaction";
  const eventParams = {
    target,
    journey_details: SEND_PAYMENT_JOURNEY_DETAILS,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackSendPaymentRequestLink = () => {
  const eventName = "click_interaction";
  const eventParams = {
    target: "send_link_click",
    journey_details: SEND_PAYMENT_JOURNEY_DETAILS,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackSendPaymentRequestLinkConfirm = () => {
  const eventName = "click_interaction";
  const eventParams = {
    target: "send_link_confirm",
    journey_details: SEND_PAYMENT_JOURNEY_DETAILS,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackSendPaymentRequestLinkSuccess = () => {
  const eventName = "click_interaction";
  const eventParams = {
    target: "send_link_alert",
    journey_details: SEND_PAYMENT_JOURNEY_DETAILS,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

const BROKER_PAYMENT_REQUEST_JOURNEY_DETAILS = "broker_payment_request";

export const trackBrokerPaymentRequestsClick = ({ target }) => {
  const eventName = "click_interaction";
  const eventParams = {
    target,
    journey_details: BROKER_PAYMENT_REQUEST_JOURNEY_DETAILS,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

const CLIENT_PAYMENT_REQUEST_JOURNEY_DETAILS = "client_payment_request";

export const trackClientPaymentRequestsClick = ({ target }) => {
  const eventName = "click_interaction";
  const eventParams = {
    target,
    journey_details: CLIENT_PAYMENT_REQUEST_JOURNEY_DETAILS,
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackProjectClick = ({ method, source, projectName }) => {
  const eventName = "project_clicked";
  const eventParams = {
    method,
    source,
    target: "projects_map_view",
    section_name: projectName,
    value: "nav projects",
  };

  ga4.trackUserInteraction(eventName, eventParams);
};
